<template>
  <aside
    class="olimpiadas-live-banner"
    :data-variant="variant"
    role="region"
    aria-label="Información de la Gran Final en vivo Olimpiadas 2026"
  >
    <p class="olimpiadas-live-banner__eyebrow">Olimpiadas Mobius 2026</p>
    <h2 class="olimpiadas-live-banner__title">Gran Final — sesión en vivo (Google Meet)</h2>
    <p class="olimpiadas-live-banner__text">
      La fase clasificatoria ya finalizó. Los clasificados deben unirse a la
      <strong>Gran Final</strong> el <strong>24 de mayo de 2026, 12:00 p.&nbsp;m.</strong>
      Hora de <strong>Colombia, Ecuador y Perú</strong> (GMT-5; misma hora civil en Bogotá, Quito y Lima).
      Si estás en otra zona, revisa la hora equivalente.
    </p>
    <a
      class="olimpiadas-live-banner__link"
      :href="meetUrl"
      target="_blank"
      rel="noopener noreferrer"
    >
      Unirse a la final en Google Meet
    </a>
  </aside>
</template>

<script>
const DEFAULT_MEET_URL = "https://meet.google.com/fem-bxga-jvu";

export default {
  name: "OlimpiadasLiveSessionBanner",
  props: {
    /** "landing" (warm gold page) | "app" (dashboard / curso, neutro) */
    variant: {
      type: String,
      default: "app",
      validator: (v) => ["landing", "app"].includes(v),
    },
    meetUrl: {
      type: String,
      default: () => DEFAULT_MEET_URL,
    },
  },
};
</script>

<style scoped>
.olimpiadas-live-banner {
  border-radius: 14px;
  padding: 1rem 1.25rem;
  max-width: 100%;
  box-sizing: border-box;
}

.olimpiadas-live-banner[data-variant="landing"] {
  margin: 0 auto 0;
  max-width: 1200px;
  padding-left: 5vw;
  padding-right: 5vw;
  padding-top: 12px;
  padding-bottom: 12px;
  background: linear-gradient(
    135deg,
    rgba(201, 162, 39, 0.18) 0%,
    rgba(184, 134, 11, 0.12) 100%
  );
  border: 1px solid rgba(184, 134, 11, 0.45);
  border-radius: 0;
  border-left: none;
  border-right: none;
}

.olimpiadas-live-banner[data-variant="app"] {
  background: #fffbeb;
  border: 1px solid #fcd34d;
  margin-bottom: 1rem;
}

.olimpiadas-live-banner__eyebrow {
  margin: 0 0 0.35rem 0;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #92400e;
}

.olimpiadas-live-banner__title {
  margin: 0 0 0.5rem 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.3;
}

.olimpiadas-live-banner__text {
  margin: 0 0 0.75rem 0;
  font-size: 0.9rem;
  line-height: 1.55;
  color: #374151;
}

.olimpiadas-live-banner__link {
  display: inline-flex;
  align-items: center;
  font-size: 0.9rem;
  font-weight: 700;
  color: #b45309;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.olimpiadas-live-banner__link:hover {
  color: #92400e;
}

.olimpiadas-live-banner[data-variant="landing"] .olimpiadas-live-banner__link {
  color: #8b6914;
}
</style>
